import { login, getUserInfo } from '@/api/user'
import { getMessageNumber } from '@/api/course'
import { getToken, setToken, removeToken, setStorgeItem } from '@/utils/auth'
// import { resetRouter } from '@/router'

const getDefaultState = () => {
  return {
    token: getToken(),
    msgNum: 0,
    userInfo: {},
    reLogin: false,
    logined: false
  }
}

const state = getDefaultState()

const mutations = {
  RESET_STATE: (state) => {
    Object.assign(state, getDefaultState())
  },
  SET_MSG_NUM: (state, num) => {
    state.msgNum = num
  },
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_USER_INFO: (state, info) => {
    state.userInfo = info
  },
  SET_RE_LOGIN: (state, flag) => {
    state.reLogin = flag
  },
  SET_LOGINED: (state, flag) => {
    state.logined = flag
  },
}

const actions = {
  // user login
  login({ commit }, userInfo) {
    const { username, password } = userInfo
    return new Promise((resolve, reject) => {
      login({ username: username.trim(), password: password }).then(response => {
        const { data } = response
        // console.log(data)
        commit('SET_TOKEN', data.token)
        // commit('SET_USER_INFO', data.loginUser)
        setToken(data.token)
        commit('SET_LOGINED', true)
        resolve()
      }).catch(error => {
        console.log(error)
        reject(error)
      })
    })
  },

  getMsgNum({ commit, state }) {
    return new Promise((resolve, reject) => {
      getMessageNumber().then(response => {
        commit('SET_MSG_NUM', response.data)
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // get user info
  getInfo({ commit, state }) {
    return new Promise((resolve, reject) => {

      getUserInfo().then(response => {
        const { data } = response

        commit('SET_USER_INFO', { ...data, defaultHeadImg: 'https://dss0.bdstatic.com/70cFuHSh_Q1YnxGkpoWK1HF6hhy/it/u=4056769380,3332572838&fm=111&gp=0.jpg' })
        commit('SET_LOGINED', true)
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // user logout
  logout({ commit, state }) {
    return new Promise((resolve, reject) => {
      // logout(state.token).then(() => {
      removeToken() // must remove  token  first
      // resetRouter()
      commit('RESET_STATE')
      commit('SET_USER_INFO', {})
      commit('SET_LOGINED', false)
      setStorgeItem('webShowAddInteres', null)
      resolve()
      // }).catch(error => {
      //   reject(error)
      // })
    })
  },

  // remove token
  resetToken({ commit }) {
    return new Promise(resolve => {
      removeToken() // must remove  token  first
      commit('RESET_STATE')
      resolve()
    })
  },
  reLogin({ commit },flag) {
    return new Promise(resolve => {
      commit('SET_RE_LOGIN',flag)
      resolve()
    })
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}




// WEBPACK FOOTER //
// ./src/store/modules/user.js